import { PERMISSIONS, type PermissionSlug } from '@/shared/permissions/permissions';

import type { GuidanceContext } from '../../types';

/**
 * The permission checks the task guides use — the SAME slugs the screens gate
 * on (`src/shared/permissions/permissions.ts`), asked through the context's
 * `can`, which is the screen's own `usePermissions().can`. Nothing here is
 * authority: it decides which guide and which steps a person is shown, and the
 * server still decides what anybody may do.
 */
export { PERMISSIONS };

/** Whether this seat holds at least one of the permissions. */
export function canAny(ctx: GuidanceContext, ...permissions: PermissionSlug[]): boolean {
  return permissions.some((permission) => ctx.can(permission));
}

/** Whether this seat holds every one of the permissions. */
export function canAll(ctx: GuidanceContext, ...permissions: PermissionSlug[]): boolean {
  return permissions.every((permission) => ctx.can(permission));
}
